<script setup lang="ts">
    defineProps<{
        body: string;
        nr: string;
        title: string;
    }>();
</script>
<template>
   <div class="content-section" >
        <div class="content-sticky-section">
            <p class="font-bold text-white/30">{{nr}}</p>
            <h3 class="headline">{{title}}</h3>
        </div>
        <div class="content-body">
            <p v-html="body" ></p>  
            <!-- <p >{{body}}</p>   -->
        </div>
    </div>
</template>